export default __webpack_public_path__ + "static/media/fecha y lugar_eng.30acadc5.png";